// extracted by mini-css-extract-plugin
export default {"pill":"_28bwo KbmUc _3cHMw _2xT3u Q8lrh oD3JI YzyUl _3nse8","pillWithoutIcon":"_2TDrH","pillIconBefore":"_2VZBe","icon":"_2rm2F"};